import React, { useRef, useState } from 'react';

import useClickOutside from '@hooks/useClickOutside';

import ProductTags from '@features/collection/details/ProductTags';

const CollectionTableTags = ({ product, productWiseTags, fetchAllTags, updateTagList }) => {
	const [isShowTags, setIsShowTags] = useState(false);
	const tagRef = useRef();

	const handleCloseTagDropdown = () => {
		setIsShowTags(false);
	};

	useClickOutside(tagRef, handleCloseTagDropdown);

	const renderProductTags = (product) => {
		return product?.tagResponseList?.map((item, index) => {
			return (
				<span
					key={`all_tags_${index}`}
					style={{ background: item.colorCode }}
					className="status radius"
				>
					{item.text}
				</span>
			);
		});
	};

	return (
		<div onClick={() => setIsShowTags(true)} className="creatable-tags">
			<div className="design-tags">{renderProductTags(product)}</div>
			{isShowTags && (
				<div ref={tagRef}>
					<ProductTags
						currentProductTagList={product.tagResponseList}
						productId={product.id}
						allTagList={productWiseTags}
						fetchAllTags={fetchAllTags}
						updateTagList={updateTagList}
					/>
				</div>
			)}
		</div>
	);
};

export default CollectionTableTags;
